export const aleaStepperStyles = {
  container: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
    mb: '50px',
    overflowY: 'visible',
  },
  stepContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    //minWidth: 'fit-content',
    width: '120px',
  },
  stepCircle: {
    base: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: '8px',
      transition: 'all 0.2s ease',
    },
    active: {
      backgroundColor: 'alea.500',
      border: '2px solid',
      borderColor: 'alea.500',
      cursor: 'pointer',
    },
    completed: {
      backgroundColor: 'alea.500',
      border: '2px solid',
      borderColor: 'alea.500',
      cursor: 'pointer',
    },
    disabled: {
      backgroundColor: '#DCDCDC',
      border: '2px solid',
      borderColor: '#DCDCDC',
      cursor: 'not-allowed',
    },
  },
  stepNumber: {
    base: {
      fontSize: '14px',
      fontWeight: '300',
      lineHeight: '1',
    },
    active: {
      color: 'white',
      fontWeight: '500',
    },
    completed: {
      color: 'white',
      fontWeight: '300',
    },
    disabled: {
      color: 'white',
    },
  },
  stepTitle: {
    base: {
      fontSize: '15px',
      fontWeight: '300',
      textAlign: 'center',
      maxWidth: '130px',
      lineHeight: '1.2',
    },
    active: {
      color: 'alea.500',
      fontWeight: '500',
    },
    completed: {
      color: 'alea.500',
      fontWeight: '300',
    },
    disabled: {
      color: '#C6C6C6',
    },
  },
  connector: {
    base: {
      height: '1px',
      width: '120px',
      mt: '16px',
      mx: '-30px',
      transition: 'all 0.2s ease',
      borderRadius: '20px',
    },
    completed: {
      backgroundColor: 'alea.500',
      height: '3px',
    },
    disabled: {
      backgroundColor: '#C6C6C6',
    },
  },
};